function init_video_events()
{
    var triggerVideoGaEvent = function(pos){

    	var data = {
          'ge_action' : 'Click',
          'ge_category' : 'HP MC Video Section',
          'ge_label' : 'position: '+pos,
          'ge_noninteraction' : false
        };

        send_ga_event(data);
    }

	//set the positon for list view video widget
	$('.list-view div.pop-wrapper .pop-item').each(function(index, el){
        $('a',el).attr('click-index', (parseInt(index)+1) );
    });

	//set the positon for grid view video widget
    $('.grid-view div.pop-wrapper .pop-item').each(function(index, el){
        $('a',el).attr('click-index', (parseInt(index)+1) );
    });

    //set the click handler to send ga event if anchor is clicked
    $('div.pop-wrapper').on('click', 'a', function(e){
        triggerVideoGaEvent($(this).attr('click-index'));
    });

    $('#popular').on('click', 'a[href="/video"]', function(e){
    	triggerVideoGaEvent(0);
    });
}

export default init_video_events;